<template>
    <MainContentSearchable title="Listado de enlaces generados para las reservas" id="reservas" v-model="filtros" :meta="reservas.meta" @updated="debouncedGetReservas">
        <template v-slot:extra-options>
            <div class="col-12 col-lg-9">
                <select class="custom-select w-auto mr-3" id="search" v-model="filtros.estado" @change="debouncedGetReservas()">
                    <option value="">ESTADOS</option>
                    <option value="0">PENDIENTE</option>
                    <option value="1">COMPRADAS</option>
                </select>
            </div>
        </template>
        
        <template v-slot:content>
            <div v-if="!loading" class="table-responsive has-options">
                <b-table
                    :items="reservas.data"
                    :fields="fields"
                    show-empty
                >
                    <template #empty>
                        <h3 class="text-center my-2">No hay enlaces generados</h3>
                    </template>
                    <template #cell(status)="data">
                        {{ data.value == 0 ? 'Pendiente' : 'Entradas compradas' }}
                    </template>
                    <template #cell(butacas)="data">
                        <b>{{ data.value.length }}</b>

                        <b-button
                            class="ml-3"
                            :id="'tooltip-target-' + data.item.id"
                            size="sm"
                            pill
                            variant="outline-secondary"
                        >
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                        </b-button>
                        <b-popover :target="'tooltip-target-' + data.item.id" triggers="hover">
                            <b-list-group flush>
                                <b-list-group-item v-for="(butaca, index) in data.value" :key="index">
                                    {{ butaca.region }} / Fila: {{ butaca.row }} / Asiento: {{ butaca.seat }}
                                </b-list-group-item> 
                            </b-list-group>
                        </b-popover>
                    </template>
                    <template #cell(opciones)="data">
                        <OpcionesDropdownComponent
                            v-if="data.item.status == 0"
                            :options="[
                                {
                                    type: 'action',
                                    action: () => copiarEnlace(data.item),
                                    label: 'Copiar enlace',
                                },
                                {
                                    type: 'action',
                                    action: () => enviarEmail(data.item),
                                    label: 'Reenviar email',
                                },
                                {
                                    type: 'action',
                                    action: () => openModal('borrarReserva', data.item),
                                    label: 'Borrar',
                                },
                            ]"
                        />
                    </template>
                </b-table>
            </div>
            <div 
                v-else
                class="col-12"
                style="margin-top: 20px; height: 100px;" 
            >
                <LoaderComponent />
            </div>
            <BorrarModalComponent
                name="borrarReserva"
                title="BORRAR RESERVA"
                borrarTitle="¿Estás seguro de que quieres borrar esta reserva?"
                confirmButton="SI, BORRAR"
                @confirm="borrarReserva()"
                @close="closeModal('borrarReserva')"
            />
        </template>
    </MainContentSearchable>
</template>

<script>
import MainContentSearchable from "@/components/backend/components/MainContentSearchable";
import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent";
import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent.vue";

export default {
    data() {
        return {
            reservas: {
                data: [],
                meta: {
                    current_page: 1,
                    last_page: 1,
                    per_page: 10,
                    total: 0,
                },
            },
            fields: [
                { key: 'email', label: 'Email' },
                { key: 'status', label: 'Estado' },
                { key: 'descuento', label: 'Descuento %' },
                { key: 'butacas', label: 'Nº butacas' },
                { key: 'created_at', label: 'Fecha' },
                { key: 'opciones', label: 'Opciones' }
            ],
            filtros: {
                search: '',
                per_page : 10,
                page: 1,
                estado: '',
            },
            debouncedGetReservas: null,
            loading: false,
            reserva: {},
        }
    },
    created() {
        this.getReservas();
        this.debouncedGetReservas = _.debounce(this.getReservas, 500);
    },
    computed: {
        footer() {
            return this.$store.getters.getFooter;
        },  
    },
    methods: {
        getReservas() {
            this.loading = true;
            const params = {
                filters: this.filtros,
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
            }
                
            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.reservas.index'), params).then(res => {
                this.reservas = res.data;
                this.loading = false;
            }).catch(() => {
                console.error('Error al recuperar el listado de reservas');
            })
        },
        copiarEnlace(reserva) {
            let text = this.footer.url_gracias + 'reservas/' + reserva.hash;
            navigator.clipboard.writeText(text);
            this.$toast.success("Url copiada!");
        },
        enviarEmail(reserva) {
            var params = {
                filters: {},
                reserva_id: reserva.id,
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
            }
            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.reservas.enviar-email'), params).then(res => {
                this.$toast.success('Correo enviado!');
            }).catch(err => {
                this.$toast.error('Error al enviar el correo');
            })
        },
        borrarReserva() {
            var params = {
                filters: {},
                reserva_id: this.reserva.id,
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
            }
            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.reservas.delete'), params).then(res => {
                this.$toast.success('Se a borrado correctamente!');
                this.closeModal('borrarReserva');
            }).catch(err => {
                this.$toast.error('Error al borrar la reserva');
                this.closeModal('borrarReserva');
            })
        },
        openModal(modal, reserva) {
            this.reserva = reserva;
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.$modal.hide(modal);
            this.getReservas();
        },
    },
    components: {
        MainContentSearchable, OpcionesDropdownComponent, BorrarModalComponent
    }
}
</script>